/* 
©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */
import { Polymer, html } from '@polymer/polymer/polymer-legacy.js';

const template = html `
<custom-style>
  <style include="corp-app-styles">
    :dir(ltr) .message {
      margin-left: 5%;
     /* margin-top: -4%; */
      /* Removing margin to make the line span till the end. Part of UI review done for add funds flow */
      /* margin-right: 4%; */
    }
	
	:dir(rtl) .message {
      margin-right: 5%;
     /* margin-top: -4%; */
      /* Removing margin to make the line span till the end. Part of UI review done for add funds flow */
      /* margin-left: 4%; */
    }
	
	.stealthy{
				display: none;
                left: 0;
                margin: 0;
                max-height: 1px;
                max-width: 1px;
                opacity: 0;
                outline: none;
                overflow: hidden;
                pointer-events: none;
                position: absolute;
                top: 0;
                z-index: -1;
            }
    .align-ev-input {
      text-align:left;
      margin-left:16px;
      margin-right:16px;
    }
		:dir(rtl) .stealthy{
			display: none;
			right: 0;
			left: auto;
			margin: 0;
			max-height: 1px;
			max-width: 1px;
			opacity: 0;
			outline: none;
			overflow: hidden;
			pointer-events: none;
			position: absolute;
			top: 0;
			z-index: -1;
        }
    	@media all and (-ms-high-contrast:none)
      	{
		oe-input {
          		--paper-input-container-label: {
              			top: -4px;
            		}
          	}
      	}
          app-dialog{
              --iron-input: {
                display:none !important;
              }
          }
          .newClass {
            --paper-input-container-label-floating_-_top: 8px!important;
            --paper-input-container-label-floating_-_left: 8px!important;
            }
  </style>
  </custom-style>

  <div class="message margin-l-zero">
    <div>	 
	  <oe-input class = "newClass" id="tpInput" label="l_TransactionPassword" required="{{required}}" type="password" value="{{wrapperValueInput}}" oncopy="return false" onpaste="return false"></oe-input>	
    </div>
  </div>`;


Polymer({
    is: 'fin-auth-transaction-pwd',
    _template: template,
    properties: {
        wrapperValue: {
            type: String,
            value: '',
            notify: true
        },
        showError: {
            type: Boolean,
            value: false,
            notify: true,
            observer: "toggleErrorMessage",
        },
        errorMessage: {
            type: String,
            value: "Minimum 6 and maximum 12 characters",
            notify: false
        },
        pattern: {
            type: String,
            value: "((?! ).)*",
            notify: false
        },
        minlength: {
            type: Number,
            value: 6,
            notify: false
        },
        maxlength: {
            type: Number,
            value: 12,
            notify: false
        },
        label: {
            type: String,
            value: "Transaction Password",
            notify: false
        },
        wrapperValueInput: {
            type: String,
            value: '',
            notify: true,
            observer: 'inputValueChanged'
        },
        isvalid: {
            type: Boolean,
            value: true,
            notify: true
        },
        required: {
            type: Boolean,
            notify: true
        }
    },
    ready: function() {
        this.toggleErrorMessage();
    },
    inputValueChanged: function() {

        var self = this;
        if (this.wrapperValue.trim().length > 0) {
            this.isvalid = true;
        } else {
            this.isvalid = false;
        }
        if (self.wrapperValueInput.trim().length > 0)
            self.wrapperValue = sbEncrypt.encrypt(self.wrapperValueInput);
        else
            self.wrapperValue = "";
    },
    attached: function() {
        // this.$$("#fmpwd2").value = "dummy";
        // this.$$("#pwd1").value = "dummy";
    },
    toggleErrorMessage: function() {
        if (this.showError) {
            this.$.tpInput.pattern = this.pattern;
            this.$.tpInput.errorMessage = this.errorMessage;
            this.$.tpInput.preventInvalidInput = true;
            this.$.tpInput.autoValidate = true;
            this.$.tpInput.minlength = 6;
            this.$.tpInput.maxlength = 12

        } else {
            this.$.tpInput.removeAttribute("pattern");
            this.$.tpInput.removeAttribute("minlength");
            this.$.tpInput.removeAttribute("maxlength");
            this.$.tpInput.removeAttribute("errorMessage");
            this.$.tpInput.preventInvalidInput = false;
            this.$.tpInput.autoValidate = false;
        }
    }
});
